<script>
// @ts-check

export default {
  data: function() {
    return {}
  },
}
</script>

<template>
  <v-card style="min-width:320px">
    <v-card-text>
      <b>TSIA</b> - Texas Success Initiative Assessment: The percentage of annual graduates who met the TSI criteria on the TSIA.
    </v-card-text>
  </v-card>
</template>
